import { render } from "./VUEComponenteGraficoRitardo.vue?vue&type=template&id=151a0bfc"
import script from "./VUEComponenteGraficoRitardo.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoRitardo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__